export default __webpack_public_path__ + "static/media/pycharm.96832ee6.png";